// enum ECurrency
// {
//     IVD = 0;    // invalid
//     AED = 1;    // U.A.E. Dirhams
//     ATS = 2;    // Austrian Schillings
//     AUD = 3;    // Australian Dollars
//     BDT = 4;    // Bangladeshi Taka
//     BEC = 5;    // Belgian Francs Commercial
//     BEL = 6;    // Belgian Francs Financial
//     BHD = 7;    // Bahraini Dinars
//     BND = 8;    // Brunei Dollars
//     BRC = 9;    // Brazil Cruzeiros
//     BUK = 10;   // Burmese Kyats
//     CAD = 11;   // Canadian Dollars
//     CHF = 12;   // Swiss Francs
//     CNY = 13;   // Chinese Renminbi
//     CYP = 14;   // Cypriot Pounds
//     DEM = 15;   // Deutsche Marks
//     DKK = 16;   // Danish Kroner
//     ECU = 17;   // European Currency Unit
//     ESP = 18;   // Spanish Pesetas
//     EUR = 19;   // Euro
//     FIM = 20;   // Finnish Markka
//     FJD = 21;   // Fiji Dollars
//     FRF = 22;   // French Francs
//     GBP = 23;   // Sterling Pounds
//     HKD = 24;   // Hong Kong Dollars
//     IDR = 25;   // Indonesian Rupiah
//     IEP = 26;   // Irish Punt
//     INR = 27;   // Indian Rupees
//     ITL = 28;   // Italian Lira
//     JPY = 29;   // Japanese Yen
//     KES = 30;   // Kenyan Shillings
//     KRW = 31;   // South Korean Won
//     KWD = 32;   // Kuwaiti Dinars
//     LBP = 33;   // Lebanese Pounds
//     LKR = 34;   // Sri Lanka Rupees
//     MOP = 35;   // Macau Patacas
//     MUR = 36;   // Mauritius Rupees
//     MXN = 37;   // Mexican Peso
//     MYR = 38;   // Malaysian Ringgit
//     NGN = 39;   // Nigerian Naira
//     NLG = 40;   // Dutch Guilders
//     NOK = 41;   // Norwegian Kroner
//     NZD = 42;   // New Zealand Dollars
//     OMR = 43;   // Omani Rials
//     PHP = 44;   // Philippine Pesos
//     PKR = 45;   // Pakistan Rupees
//     PTE = 46;   // Portuguese Escudos
//     QAR = 47;   // Qatar Riyals
//     SAR = 48;   // Saudi Arabian Riyals
//     SCR = 49;   // Seychelles Rupees
//     SDR = 50;   // Special Drawing Rights
//     SEK = 51;   // Swedish Kronor
//     SGD = 52;   // Singapore Dollars
//     SLL = 53;   // Sierra Leone Leones
//     THB = 54;   // Thai Baht
//     USD = 55;   // US Dollars
//     ZAR = 56;   // South African Rand
//     CNH = 57;   // Offshore Chinese Yuan
//     TRY = 58;   // Turkish Lira
//     TWD = 59;   // New Taiwan Dollar
//     //BTC = 60;   // Bitcoin
//     ARS = 61;   // Argentine Peso
//     BGN = 62;   // Bulgarian Lev
//     BRL = 63;   // Brazilian Real
//     CLP = 64;   // Chilean Peso
//     COP = 65;   // Colombian Peso
//     CZK = 66;   // Czech Koruna
//     EGP = 67;   // Egyptian Pound
//     HUF = 68;   // Hungarian Forint
//     ILS = 69;   // Israeli New Shekel
//     JMD = 70;   // Jamaican Dollar
//     KZT = 71;   // Kazakhstani Tenge
//     PEN = 72;   // Peruvian Sol
//     PGK = 73;   // Papua New Guinean Kina
//     PLN = 74;   // Polish Zloty
//     RON = 75;   // Romanian Leu
//     RUB = 76;   // Russian Ruble

//     // 加密货币
//     BTC = 60;   // Bitcoin

//     // 贵金属
//     XAG = 1000;   // Silver
//     XAU = 1001;   // Gold
// };


// 根据上面的枚举，实现一个方法，传递货币值返回对应的货币符号，如传递 24 返回 HKD，要有 HKD，USD，SGD 的返回值
export const getCurrencySymbol = (currencyCode) => {
    // HKD, CNY, USD, SGD, JPY, MYR, CAD, AUD
    switch (currencyCode) {
        case 13: return 'CNY';
        case 23: return 'GBP';
        case 24: return 'HKD';
        case 55: return 'USD';
        case 52: return 'SGD';
        case 29: return 'JPY';
        case 38: return 'MYR';
        case 11: return 'CAD';
        case 3: return 'AUD';
        default: return '-';
    }
};
